import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const user = 'user';

const apiRoutes = {
	clientUsers: user + '/client-users',
	clientUser: user + '/client-user',
}

@Injectable({ providedIn: 'root' })
export class UserService {

	constructor(private http: HttpClient) { }

	getClientUsers(params: any) {
		return this.http.get<any>(environment.api + apiRoutes.clientUsers, { params: params });
	}

	getClientUsersForAssign(project_id: number, params: any) {
		return this.http.get<any>(environment.api + apiRoutes.clientUsers + '/assign/' + project_id, { params: params });
	}

	inviteNewUser(data: any) {
		return this.http.post<any>(environment.api + apiRoutes.clientUser, data);
	}

	reinviteNewUser(client_user_id: number) {
		return this.http.patch<any>(environment.api + apiRoutes.clientUser + '/reinvite/' + client_user_id, {});
	}

	clientUserApprove(client_user_id: number) {
		return this.http.patch<any>(environment.api + apiRoutes.clientUser + '/approve/' + client_user_id, {});
	}

	clientUserDecline(client_user_id: number) {
		return this.http.patch<any>(environment.api + apiRoutes.clientUser + '/decline/' + client_user_id, {});
	}

	updateClientUserRoles(client_user_id: number, data: any) {
		return this.http.patch<any>(environment.api + apiRoutes.clientUser + '/roles/' + client_user_id, data);
	}

	updateClientUserStatus(client_user_id: number, data: any) {
		return this.http.patch<any>(environment.api + apiRoutes.clientUser + '/status/' + client_user_id, data);
	}
}